"use client";

import { useAuth } from "@pex/auth/client";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "../ui/button";

export function LogoutButton({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Button>) {
  const router = useRouter();
  const { signOut } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      await signOut();
      // Use Next.js router for smooth navigation
      router.push("/login");
      router.refresh();
    } catch (error) {
      console.error("Logout error:", error);
      setIsLoading(false);
    }
  };

  return (
    <Button
      className={className}
      disabled={isLoading}
      onClick={handleLogout}
      {...props}
    >
      {isLoading ? "Logging out..." : "Logout"}
    </Button>
  );
}
